var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.875,
    height: 21.251,
    viewBox: "0 0 30.875 21.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8817",
    "data-name": "Group 8817",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M32.3,29.5a4.361,4.361,0,0,1,4.36,4.266v8.2L41.6,46.81a.451.451,0,0,0,.6.025l.034-.031a.451.451,0,0,0,.127-.272l0-.044V33.156a.451.451,0,0,0-.737-.349l-.033.03L38.843,35.6l-1.063-1.063,2.758-2.758a1.955,1.955,0,0,1,3.336,1.312v13.4a1.955,1.955,0,0,1-3.267,1.449l-.056-.053-5.173-5.065a.752.752,0,0,1-.223-.477l0-.06V33.861A2.857,2.857,0,0,0,32.378,31H17.861A2.857,2.857,0,0,0,15,33.779V47.093a1.654,1.654,0,0,0,1.588,1.653H32.3a2.857,2.857,0,0,0,2.856-2.776V45.89h1.5a4.361,4.361,0,0,1-4.266,4.36H16.658A3.158,3.158,0,0,1,13.5,47.179V33.861a4.361,4.361,0,0,1,4.266-4.36H32.3Z",
    transform: "translate(-13.5 -29.5)",
    fill: "#5d0d19",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoShopping);
export default __webpack_public_path__ + "static/media/video-shopping.e05a939ced0aa99e92bc8ee9a65fca14.svg";
export { ForwardRef as ReactComponent };